var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultBun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#8879d5",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.639 501.639",
    xmlSpace: "preserve",
    stroke: "#8879d5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 277.015 150.831 L 251.319 149.906 C 153.564 149.906 46.515 239.962 45.593 349.82 L 45.593 355.002 C 45.593 366.401 53.892 375.729 64.036 375.729 C 59.964 425.946 460.061 441.503 456.898 375.729 C 466.12 375.729 474.42 366.401 475.341 356.038 L 475.341 350.856 C 475.342 239.962 374.769 150.831 277.015 150.831 Z",
    style: {
      paintOrder: "fill",
      fillOpacity: 0.19,
      fill: "rgba(0, 0, 0, 0)",
      strokeMiterlimit: 1,
      strokeWidth: 41,
      strokeDashoffset: 1,
      stroke: "rgba(116, 116, 116, 0.71)"
    },
    transform: "matrix(1, 0, 0, 1, -10.466996, -53.963773)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBun);
export default __webpack_public_path__ + "static/media/default-bun.5ffc1c5f68747c81af8d6b4292c84f9d.svg";
export { ForwardRef as ReactComponent };